import { del, get, post, put } from "../api"
import * as url from "./urls"

const getProducts = () => {
  return get(url.GET_PRODUCTS)
}

const getAllProducts = () => {
  return get(url.GET_ALL_PRODUCTS)
}

const deleteProduct = id => {
  const endpoint = url.DELETE_PRODUCT_BY_ID.replace(":id", id)
  return del(endpoint)
}

const restoreProduct = id => {
  const endpoint = url.RESTORE_PRODUCT_BY_ID.replace(":id", id)
  return post(endpoint)
}

const createProduct = data => {
  return post(url.POST_PRODUCT, data)
}

const updateProduct = (id, data) => {
  const endpoint = url.UPDATE_PRODUCT.replace(":id", id)
  return post(endpoint, data)
}

export {
  getProducts,
  getAllProducts,
  deleteProduct,
  restoreProduct,
  createProduct,
  updateProduct,
}
